<ng-container *ngIf="display$ | async">

  <ng-container *ngIf="viewModel$ | async as vm">
    <app-dataset-card (click)="selectNoise(vm.module)"
      [selected]="sidebarRoomService.isSelected(vm.card, vm.module, GraphType.NOISE)"
      [backgroundColor]="'var(--blue-10)'"
      [hoverBackgroundColor]="'var(--blue-5)'">
      <app-dataset-card-label>{{ 'common-app.__NOISE' | LANG }}</app-dataset-card-label>
      <app-dataset-card-value class="text-blue">{{ vm.module.Noise ?? '--' }}</app-dataset-card-value>
      <app-dataset-card-unit>
        <app-text unit [measureType]="EnumMeasureTypes.NOISE"></app-text>
      </app-dataset-card-unit>
      <app-dataset-card-preview [module]="vm.module" [measureType]="EnumMeasureTypes.NOISE"></app-dataset-card-preview>
    </app-dataset-card>
  </ng-container>

</ng-container>
